"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var builder_1 = require("./builder");
var Query = /** @class */ (function (_super) {
    __extends(Query, _super);
    function Query() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clauses = [];
        return _this;
    }
    /**
     * Adds a clause to the query list.
     * @param {Clause} clause
     */
    Query.prototype.addClause = function (clause) {
        this.clauses.push(clause);
        return this;
    };
    Query.prototype.build = function () {
        return "" + lodash_1.map(this.clauses, function (s) { return s.build(); }).join('\n');
    };
    return Query;
}(builder_1.Builder));
exports.Query = Query;
